export const BUSINESS = {
  name: "DMS Home Improvements",
  legalName: "DMS Home Improvements",
  phone: "07895 334 549",
  phoneHref: "tel:+447895334549",
  phoneE164: "+447895334549",
  whatsappHref: "https://wa.me/447895334549",
  email: "info@dmshomeimprovements.co.uk",
  address: {
    street: "Molesey",
    locality: "East Molesey",
    region: "Surrey",
    postcode: "KT8",
    country: "GB",
  },
  hours: "Mon–Fri 8:00am–6:00pm · Sat 8:00am–1:00pm",
  companyNumber: "TBC",
  googleUrl: "[GOOGLE BUSINESS PROFILE URL]",
  founderFirstName: "Dave",
  siteUrl: "https://www.dmshomeimprovements.co.uk",
};

export const NAV = [
  { id: "services", label: "Services", to: "/services" },
  { id: "gallery", label: "Our Work", to: "/gallery" },
  { id: "about", label: "About", to: "/about" },
  { id: "reviews", label: "Reviews", to: "/reviews" },
  { id: "areas", label: "Areas", to: "/areas" },
  { id: "advice", label: "Advice", to: "/advice" },
];

export const SERVICES = [
  {
    id: "extensions",
    title: "Extensions",
    to: "/extensions",
    line: "Single and double-storey extensions, built to last.",
    slot: { id: "house-extension-molesey.webp", note: "PHOTO NEEDED: finished single-storey rear extension, landscape, min 1600px wide" },
    alt: "Single-storey rear house extension in Molesey by DMS Home Improvements",
  },
  {
    id: "plastering",
    title: "Plastering",
    to: "/plastering",
    line: "Skimming, rendering, dry lining and ceiling repairs.",
    slot: { id: "plastering-kingston-upon-thames.webp", note: "PHOTO NEEDED: freshly skimmed wall or ceiling, landscape, min 1600px wide" },
    alt: "Freshly skimmed plastering in Kingston upon Thames by DMS Home Improvements",
  },
  {
    id: "loft-conversions",
    title: "Loft Conversions",
    to: "/loft-conversions",
    line: "Turn your loft into a bedroom, office or bathroom.",
    slot: { id: "loft-conversion-surbiton.webp", note: "PHOTO NEEDED: finished loft bedroom with dormer window, landscape, min 1600px wide" },
    alt: "Dormer loft conversion bedroom in Surbiton by DMS Home Improvements",
  },
  {
    id: "kitchens",
    title: "Kitchens",
    to: "/kitchens",
    line: "Full kitchen fitting, from rip-out to finished room.",
    slot: { id: "kitchen-fitting-thames-ditton.webp", note: "PHOTO NEEDED: finished fitted kitchen, landscape, min 1600px wide" },
    alt: "Fitted shaker kitchen in Thames Ditton by DMS Home Improvements",
  },
  {
    id: "bathrooms",
    title: "Bathrooms",
    to: "/bathrooms",
    line: "Modern bathroom installs, tiling and plumbing.",
    slot: { id: "bathroom-installation-esher.webp", note: "PHOTO NEEDED: finished tiled bathroom, landscape, min 1600px wide" },
    alt: "Modern bathroom installation in Esher by DMS Home Improvements",
  },
  {
    id: "refurbishments",
    title: "Refurbishments",
    to: "/refurbishments",
    line: "Full property renovations and modernisation.",
    slot: { id: "house-refurbishment-kingston.webp", note: "PHOTO NEEDED: finished refurbished living room or whole property, landscape, min 1600px wide" },
    alt: "Full house refurbishment living room in Kingston by DMS Home Improvements",
  },
];

export const AREAS = [
  { id: "molesey", name: "Molesey", to: "/builders-molesey" },
  { id: "east-molesey", name: "East Molesey", to: "/builders-east-molesey" },
  { id: "west-molesey", name: "West Molesey", to: "/builders-west-molesey" },
  { id: "kingston-upon-thames", name: "Kingston upon Thames", to: "/builders-kingston-upon-thames" },
  { id: "surbiton", name: "Surbiton", to: "/builders-surbiton" },
  { id: "thames-ditton", name: "Thames Ditton", to: "/builders-thames-ditton" },
  { id: "esher", name: "Esher", to: "/builders-esher" },
  { id: "cobham", name: "Cobham", to: "/builders-cobham" },
];

export const SHOWCASE = [
  {
    id: "rear-extension-thames-ditton",
    caption: "Rear extension, Thames Ditton",
    service: "extensions",
    before: { id: "rear-extension-thames-ditton-before.webp", alt: "Rear of house in Thames Ditton before extension by DMS Home Improvements" },
    after: { id: "rear-extension-thames-ditton-after.webp", alt: "Rear extension in Thames Ditton by DMS Home Improvements" },
  },
  {
    id: "loft-conversion-kingston",
    caption: "Loft conversion, Kingston",
    service: "loft-conversions",
    before: { id: "loft-conversion-kingston-before.webp", alt: "Unconverted loft in Kingston before conversion by DMS Home Improvements" },
    after: { id: "loft-conversion-kingston-after.webp", alt: "Loft conversion bedroom in Kingston by DMS Home Improvements" },
  },
  {
    id: "kitchen-refurbishment-molesey",
    caption: "Kitchen refurbishment, Molesey",
    service: "kitchens",
    before: { id: "kitchen-refurbishment-molesey-before.webp", alt: "Dated kitchen in Molesey before refurbishment by DMS Home Improvements" },
    after: { id: "kitchen-refurbishment-molesey-after.webp", alt: "Kitchen refurbishment in Molesey by DMS Home Improvements" },
  },
];

export const PROCESS = [
  { step: "01", title: "Free Site Visit", text: "We come to you. No charge, no pressure." },
  { step: "02", title: "Fixed Written Quote", text: "A clear, itemised price, valid for 30 days." },
  { step: "03", title: "The Build", text: "Start date agreed up front. Tidy site every day." },
  { step: "04", title: "Aftercare", text: "12-month workmanship guarantee on everything we do." },
];

export const TRUST_ITEMS = [
  { id: "insured", label: "Fully Insured" },
  { id: "quotes", label: "Free No-Obligation Quotes" },
  { id: "experience", label: "20+ Years' Experience" },
  { id: "local", label: "Local to Molesey & Kingston" },
];
